import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';
import ModalActions from '../../actions/ModalActions';
import { GlobalModals } from '../../constants/AppConstants';

import Icon from './Icon';
import BaseModal from './BaseModal';
import BAlert, { bAlertType } from './BAlert';


function ErrorModal ({ heading, title, message, closeText, onClose, customButton = {}, router }) {

    function _getModalProps(headingText, { text = null, onClick = _.noop }) {
        const closeHandler = () => {
            ModalActions.close(GlobalModals.ERROR);
            onClose();
        };
        const customHandler = (...args) => {
            onClick.call(router, ...args);
            ModalActions.close(GlobalModals.ERROR);
            onClose();
        };
        let props = {};

        if (!_.isNull(text)) {
            props = { continueText: text, closeText, onContinue: customHandler, onClose: closeHandler };
        }

        return Object.assign({
            closeText: closeText,
            onClose: closeHandler,
            hideContinue: _.isNull(text),
            className: 'modal--sm',
            titleText: headingText
        }, props);
    }

    return (
        <BaseModal { ..._getModalProps(heading, customButton) }>
            <div className="vertical-align-parent full-height">
                <BAlert type={ bAlertType.DANGER } className="padding-top">
                    <p className="text-weight--bold">
                        <Icon icon="error" /> { t(title) }
                    </p>
                    <p>{ t(message) }</p>
                </BAlert>
            </div>
        </BaseModal>
    );
}

ErrorModal.propTypes = {
    heading: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    closeText: PropTypes.string,
    customButton: PropTypes.shape({
        text: PropTypes.string,
        onClick: PropTypes.func
    }),
    onClose: PropTypes.func,
    router: PropTypes.object
};

ErrorModal.defaultProps = {
    heading: 'error.title',
    title: 'error.general.title',
    message: 'error.general.message',
    closeText: 'button.text.close',
    onClose: _.noop
};

export default ErrorModal;
